/* global YT */
( function( $ ) {
	var tag = document.createElement( 'script' );
	tag.src = 'https://www.youtube.com/iframe_api';
	var firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
	firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

	const SELECTOR_IFRAME = '.video__poster--youtube iframe';
	const CLASS_WRAPPER = 'video__poster';
	const CLASS_POSTER = 'video__thumb';
	const CLASS_PLAYING = 'video__poster--playing';
	const CLASS_TRANSITIONED = 'video__poster--transitioned';

	window.onYouTubeIframeAPIReady = function() {
		$( SELECTOR_IFRAME ).each( function() {
			new YT.Player( $( this ).attr( 'id' ), {
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			} );

			// Prevent tabindex when not playing
			$( this ).attr( 'tabindex', '-1' );
		} );
	};

	function onPlayerReady( playerEvent ) {
		var $iframe = $( playerEvent.target.getIframe() );
		var $wrapper = $iframe.closest( '.' + CLASS_WRAPPER );
		var $poster = $wrapper.find( '.' + CLASS_POSTER );

		$poster.on( 'click.youtube', function() {
			playerEvent.target.playVideo();
		} );
	}

	function onPlayerStateChange( event ) {
		var $iframe = $( event.target.getIframe() );
		var $wrapper = $iframe.closest( '.' + CLASS_WRAPPER );
		var $poster = $wrapper.find( '.' + CLASS_POSTER );

		switch ( event.data ) {
			case YT.PlayerState.UNSTARTED:
			case YT.PlayerState.BUFFERING:
			case YT.PlayerState.PLAYING:
				$wrapper.removeClass( CLASS_TRANSITIONED );
				$poster.one( 'transitionend.youtube', function() {
					$wrapper.addClass( CLASS_TRANSITIONED );
				} );
				$wrapper.addClass( CLASS_PLAYING );

				setTimeout( function() {
					$iframe.attr( 'tabindex', 0 ).get( 0 ).focus(); // apply focus when video is playing
				}, 1 );
				break;

			case YT.PlayerState.PAUSED:
			case YT.PlayerState.ENDED:
				$wrapper.removeClass( CLASS_TRANSITIONED );
				$iframe.attr( 'tabindex', '-1' ).one( 'transitionend.youtube', function() {
					$wrapper.addClass( CLASS_TRANSITIONED );
				} );
				$wrapper.removeClass( CLASS_PLAYING );

				setTimeout( function() {
					$poster.get( 0 ).focus(); // apply focus back to poster when video is paused/ended
				}, 1 );
				break;
		}
	}
} )( jQuery );